export function clean(obj) {
  const result = { ...obj };
  for (const key of Object.keys(obj)) {
    if (obj[key] === undefined) {
      delete result[key];
    }
  }
  return result;
}
